export default "__VITE_ASSET__BaFanz2V__"